<template>
    <button @click.prevent="toggleModal" :class="styles" type="button">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "ModalButton",

    props: {
        target: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'btn-info'
        }
    },

    computed: {
        styles() {
            return 'btn ' + this.type;
        }
    },

    methods: {
        toggleModal() {
            EventBus.$emit('modal-custom', { name: this.target });
        }
    }
}
</script>

<style>

</style>